import development from './kitfit-community-dev.json'
import uat from './kitfit-community-uat.json'

let firebaseConfig = development
if (process.env.REACT_APP_FIREBASE_ENV === 'uat') {
	firebaseConfig = uat
}

export default firebaseConfig
